// public/js/features/manual/manual-assets.js
// Device images live on the shared static S3 origin under /devices (uploaded at
// release time). Falls back to the bundled local copy when STATIC_BASE is unset
// (e.g. a purely local run). See docs/device-manual.md.
export function deviceAssetUrl(file) {
  if (!file) return null;
  const base = (typeof window !== 'undefined' && window.STATIC_BASE) || '';
  // Cache-buster: same filename can get new artwork, so version the URL by
  // assetVersion (bumped on every deploy) - otherwise browsers keep the old image.
  const ver = (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.ASSET_VERSION) || '';
  const q = ver ? `?v=${ver}` : '';
  return base ? `${base}/devices/${file}${q}` : `img/devices/${file}${q}`;
}
